import { render, staticRenderFns } from "./HeatMapSync.vue?vue&type=template&id=70daf1c4&scoped=true"
import script from "./HeatMapSync.vue?vue&type=script&lang=js"
export * from "./HeatMapSync.vue?vue&type=script&lang=js"
import style0 from "./HeatMapSync.vue?vue&type=style&index=0&id=70daf1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70daf1c4",
  null
  
)

export default component.exports